import type { Student, Bus } from '../lib/types';

interface BusSelectorProps {
  students: Student[];
  buses: Bus[];
  selectedBusId: string | null;
  onSelect: (busId: string) => void;
}

export function BusSelector({
  students,
  buses,
  selectedBusId,
  onSelect,
}: BusSelectorProps) {
  if (!students.length) {
    return <div className="bus-selector-empty">No children registered</div>;
  }

  return (
    <div className="bus-selector">
      {students.map((student) => {
        const bus = buses.find((b) => b.id === student.bus_id);
        if (!bus) return null;

        const isActive = bus.id === selectedBusId;

        return (
          <button
            key={student.id}
            className={`bus-selector-item ${isActive ? 'active' : ''}`}
            onClick={() => onSelect(bus.id)}
          >
            <div className="bus-selector-child">{student.name}</div>
            <div className="bus-selector-bus">
              {bus.bus_number}
              {student.stop_name && ` - ${student.stop_name}`}
            </div>
          </button>
        );
      })}
    </div>
  );
}
